import { useLang } from '../../contexts/LangContext'

const labels = {
  pending: { el: 'Σε αναμονή', en: 'Pending' },
  approved: { el: 'Εγκεκριμένος', en: 'Approved' },
  suspended: { el: 'Σε αναστολή', en: 'Suspended' },
  rejected: { el: 'Απορρίφθηκε', en: 'Rejected' },
} as const

const classes: Record<string, string> = {
  pending: 'border-amber-200 bg-amber-50 text-amber-700',
  approved: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  suspended: 'border-rose-200 bg-rose-50 text-rose-700',
  rejected: 'border-slate-200 bg-slate-100 text-slate-700',
}

export default function ProviderStatusBadge({ status }: { status: string }) {
  const { locale } = useLang()
  const label = labels[status as keyof typeof labels]

  return (
    <span
      className={[
        'inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em]',
        classes[status] ?? 'border-slate-200 bg-slate-100 text-slate-700',
      ].join(' ')}
    >
      {label ? label[locale] : status}
    </span>
  )
}
